module.exports = __webpack_public_path__ + "static/img/1_1_4.cf8e0e8a.jpg";